import { Injectable } from '@angular/core'
import { ContextService } from './context.service'

@Injectable({
  providedIn: 'root',
})
export class SectionService {
  constructor(protected context: ContextService) {}

  _mapModeToFrom(mapMode) {
    const relation = {
      census: 'census',
      neighborhood: 'neighborhoods',
      grid: 'municipalities',
      pois: 'pois',
      ccaa: 'ccaa',
    }
    return relation[mapMode] || mapMode
  }

  _mapModeToTerrunit(mapMode) {
    if (mapMode && /^\d+$/.test(mapMode.toString())) {
      return mapMode
    }

    return mapMode
  }

  _filterFromContext() {
    return this.context
      .getDeliveryFilters()
      .filter((f) => f.value)
      .map((f) => f.value)
      .join('-')
  }

  /**
   * Ensure non-mobility filter is returned (there are services in
   * the mobility sections that uses dst_abs data and needs access to
   * dst_abs filters)
   */
  _filterFromContextDst() {
    return this.context
      .getDeliveryFiltersDst()
      .map((f) => f.value)
      .join('-')
  }

  _variablesFromContext(context) {
    if (!context.target) {
      return
    }
    const targetKey = Object.keys(context.target).find(
      (key) => !!context.target[key],
    )
    let targetFilter = context.target[targetKey]
    if (targetFilter && !Array.isArray(targetFilter)) {
      targetFilter = [targetFilter]
    }

    if (!targetFilter) {
      targetFilter = [this.context.keyIndicator.value]
    }

    return targetFilter
  }
}
